import { ThemeProps as Prop, StaticProfiles } from '@powdr/constants';

export const StaticTheme = {
  [StaticProfiles.COLORS]: {
    [Prop.BLACK]: '#000000',
    [Prop.WHITE]: '#FFFFFF',
  },
  [StaticProfiles.SHADES]: {
    [Prop.LIGHTEST]: '#F0F0F0',
    [Prop.LIGHTER]: '#E0E0E0',
    [Prop.LIGHT]: '#CCCCCC',
    [Prop.GRAY]: '#8B8B8B',
    [Prop.GRAYER]: '#696969',
    [Prop.GRAYEST]: '#525257',
    [Prop.DARK]: '#333333',
    [Prop.DARKER]: '#222222',
    [Prop.DARKEST]: '#292929',
  },
  [StaticProfiles.DIFFICULTY]: {
    [Prop.BEGINNER]: '#73C053',
    [Prop.INTERMEDIATE]: '#30A8E0',
    [Prop.EXPERT]: '#000000',
  },
  [StaticProfiles.SOCIAL]: {
    [Prop.FACEBOOK]: '#3B5998',
    [Prop.EVENTBRITE]: '#F6682F',
  },
  [StaticProfiles.ALERTS]: {
    [Prop.ACTIVE]: '#2176b8',
    [Prop.SUCCESS]: '#73c053',
    [Prop.INFO]: '#0b24fb',
    [Prop.WARNING]: '#FFB400',
    [Prop.DANGER]: '#FE4A49',
    [Prop.EXPECTED]: '#FFB400',
    [Prop.ON_HOLD]: '#FFB400',
    [Prop.ALERT_WARNING_BG]: '#FFB400',
    [Prop.ALERT_WARNING_CONTENT]: '#000000',
    [Prop.ALERT_DANGER_BG]: '#FE4A49',
    [Prop.ALERT_DANGER_CONTENT]: '#FFFFFF',
  },
  [StaticProfiles.PARKING_CALENDAR]: {
    [Prop.SECTION_BG]: '#f0f0f0',
    [Prop.SECTION_TXT]: '#4D5859',
    [Prop.ITEM_BG]: '#DCDCDC',
    [Prop.ITEM_TXT]: '#4D5859',
    [Prop.ITEM_TXT_HOVER]: '#00AEBB',
    [Prop.ITEM_BG_NO_INTERACT]: '#ECECEC',
    [Prop.ITEM_TXT_NO_INTERACT]: '#B2B6B5',
    [Prop.ITEM_BG_AVAILABLE]: '#00AEBB',
    [Prop.ITEM_TXT_AVAILABLE]: '#FFFFFF',
    [Prop.ITEM_BTN_BG_AVAILABLE]: '#D4441C',
    [Prop.ITEM_BTN_TXT_AVAILABLE]: '#FFFFFF',
    [Prop.ITEM_BG_SELECTED]: '#126978',
    [Prop.ITEM_TXT_SELECTED]: '#FFFFFF',
    [Prop.ITEM_BTN_BG_SELECTED]: '#D4441C',
    [Prop.ITEM_BTN_TXT_SELECTED]: '#FFFFFF',
    [Prop.RES_ITEM_CONTAINER_BG]: '#FFFFFF',
  },
  [StaticProfiles.TV]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.HEADER]: '#3F3F3F',
    [Prop.CONTENT]: '#3F3F3F',
    [Prop.BORDER]: '#3F3F3F',
    [Prop.ICON]: '#00b6ea',
    [Prop.LINK]: '#00b6ea',
    [Prop.LINK_HOVER]: '#00b6ea',
    [Prop.ODD_EVEN_OFFSET]: '#E5EDED',
    [Prop.SIDE_NAV_ITEM_BG]: '#00b6ea',
    [Prop.SIDE_NAV_ITEM_TXT]: '#FFFFFF',
    [Prop.SIDE_NAV_ITEM_ICON]: '#FFFFFF',
    [Prop.SIDE_NAV_ITEM_BG_ACTIVE]: '#3F3F3F',
    [Prop.SIDE_NAV_ITEM_TXT_ACTIVE]: '#FFFFFF',
    [Prop.SIDE_NAV_ITEM_ICON_ACTIVE]: '#FFFFFF',
    [Prop.TOP_NAV_ITEM_TXT]: '#FFFFFF',
  },
};
